// extracted by mini-css-extract-plugin
export default {"checkboxList":"CheckboxList_checkboxList__1QwOh","checkbox":"CheckboxList_checkbox__DPZy8"};